import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment } from '@angular/router';


import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { LoginService } from '@xpo-ltl/login';
import { User } from '@xpo-ltl/sdk-common';

import { NotAuthorizedComponent } from '@core/layout/not-authorized/not-authorized.component';
import { ConfigManagerProperties } from '@shared/enums';
import { InvoiceAuditorService } from '@shared/services/invoice-auditor/invoice-auditor.service';

@Injectable({ providedIn: 'root' })
export class RoleCheckGuard implements CanActivate, CanLoad {
  constructor(
    private dialog: MatDialog,
    private config: ConfigManagerService,
    private loginService: LoginService,
    private invoiceAuditorService: InvoiceAuditorService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return this.isAuthorized();
  }

  canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
    return this.isAuthorized();
  }

  private isAuthorized(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const failGuardFunc = () => {
        this.invoiceAuditorService.user = undefined;
        this.showNotAuthorizedDialog();
        reject();
      };

      this.loginService.getLoggedInUser(this.config.getSetting(ConfigManagerProperties.loggedInUserRoot)).subscribe(
        (user: User) => {
          if (this.invoiceAuditorService.isAuthorizedUser(user.roles)) {
            this.invoiceAuditorService.user = user;
            this.invoiceAuditorService.userRoles = user.roles;
            resolve(true);
            return;
          } else {
            failGuardFunc();
          }
        },
        () => {
          failGuardFunc();
        }
      );
    });
  }

  private showNotAuthorizedDialog() {
    this.dialog.open(NotAuthorizedComponent, { disableClose: true });
  }
}
